import type { ContentBlockT, ConversationMessageT } from '@lotushealth/lotushealth_js_sdk/schemas';

function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object';
}

function getContentBlockType(block: ContentBlockT): string | null {
  const body = block.body;
  if (!isRecord(body)) {
    return null;
  }
  const type = body.type;
  return typeof type === 'string' ? type : null;
}

export function isAttachmentContentBlock(block: ContentBlockT): boolean {
  return getContentBlockType(block) === 'fileAttachment';
}

export function hasAttachmentContentBlock(
  message: Pick<ConversationMessageT, 'contentBlocks'>
): boolean {
  return message.contentBlocks.some((block) => isAttachmentContentBlock(block));
}
